module.exports = __webpack_public_path__ + "images/getbikeservice31a35c178792599d5a85885f113dd2af.png";